import React, { Component } from 'react';
import { Trans } from '@lingui/macro';

// COMPONENTS
import { Typography, Button, Card, CoreIcons } from 'components';
import Row from '../../../components/Row';

import * as routes from './../../../settings/_routesSettings';
import { history } from '../../../routers/AppRouter';

class FirstTime extends Component {
  state = { firstName: 'Felipe' }

  handleButtons = (hasRequest) => {
    history.push(hasRequest ?
      routes.CHECKOUT_PLANS_MEDICAL_REQUEST :
      routes.CHECKOUT_PLANS_DETAILS);
  }

  render() {
    const { firstName } = this.state;

    return (
      <div className="CheckoutPlans">
        <div className="CheckoutPlans__header">
          <Row align='center' justify='center' margin='2rem 0 0.5rem'>
            <Typography
              align='center'
              style={{ width: '100%' }}
              type='title'>
              <Trans>Detalhes do agendamento</Trans>
            </Typography>
          </Row>

          <Row align='center' justify='center' margin='0 0 2rem'>
            <Typography
              align='center'
              color="grey-dark"
              style={{ width: '100%' }}
              type='paragraph'>
              <Trans>Passo 1 de 2</Trans>
            </Typography>
          </Row>
        </div>

        <div className="CheckoutPlans__content">
          <div className="FirstTime">
            <Card>
              <CoreIcons name='MedicalRequest' height="128px" width="165.35px" />

              <Typography
                align="center"
                color="color-title"
                style={{ margin: '1.496rem 0 1.504rem' }}
                type="subtitle">
                {`${firstName}, você possui pedido\n médico para esta consulta?`}
              </Typography>

              <div className="Card__buttons" >
                <Button id="btn-yes" onButtonClick={() => this.handleButtons(true)} text="sim" />
                <Button id="btn-no" onButtonClick={() => this.handleButtons()} text="não" />
              </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

export default FirstTime;